import BranchService from './branch.service';

export default BranchService;
